import React from 'react';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';

import {withRouter} from 'react-router';
import {isMobile} from '../../app/configuration/util';
import MobileLibrary from './MobileLibrary';
import DesktopLibrary from './DesktopLibrary';
import Filters from '../../LibraryFilter/component/LibraryFilters';
import ViAppBar from '../../components/ViAppBar';

class Library extends React.PureComponent {

  componentDidMount() {
    const systemId = localStorage.getItem('systemId');
    if (systemId && systemId === 'geotab') {
      window.addEventListener('resize', this.dimensions);
      this.dimensions();
    }
  }

  dimensions = () => {
    const root = document.getElementById('root');
    const menuGeotab = document.getElementById('menuId');
    if (menuGeotab && !menuGeotab.classList.contains('menuCollapsed') && !root.classList.contains('geotab-collapsed')) {
      root.classList.add('geotab-collapsed');
    } else if (menuGeotab && menuGeotab.classList.contains('menuCollapsed') && root.classList.contains('geotab-collapsed')) {
      root.classList.remove('geotab-collapsed');
    }
  }

  renderLibrary() {
    if (this.props.isMobile) {
      return (
        <div>
          <MobileLibrary {...this.props} />
        </div>
      );
    }
    return <DesktopLibrary {...this.props} />;
  }

  renderViAppBar() {
    const systemId = localStorage.getItem('systemId');
    if (!(systemId && systemId === 'geotab')) {
      return (
        <ViAppBar auth={this.props.auth} title={I18n.t('page.library.title')} >
          {this.props.isMobile && <Filters />}
        </ViAppBar>
      );
    }
    return null;
  }

  render() {
    let className = 'bodycontent';
    className += (this.props.isMobile) ? ' bodycontent__librarymobile' : ' bodycontent__librarydesktop';

    return (
      <div>
        <div className="whitecover" />
        {this.renderViAppBar()}
        <div className={className}>
          {this.renderLibrary()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {isMobile: isMobile(state)};
}

export default withRouter(connect(mapStateToProps)(Library));
